usersModule.controller('UsersController', ['$scope', 'growl', 'usersMgEvents',  function ($scope, growl, usersMgEvents) {

    $scope.$on(usersMgEvents.searchUserSelected, function(event, user) {
        $scope.$emit(usersMgEvents.userSelected, user);
    });
    $scope.$on(usersMgEvents.userCreate, function(event, user) {
        $scope.$emit(usersMgEvents.userCreated, user);
    });
    $scope.$on(usersMgEvents.userClear, function(event) {
        $scope.$emit(usersMgEvents.userCleared);
    });
    $scope.$on(usersMgEvents.userUpdate, function(event, user) {
        $scope.$emit(usersMgEvents.userUpdated, user);
    });
}]);